import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import './Report.css';

export default function Report() {
    const { companyId, orgCode } = useParams();
    const paramCompany = companyId || orgCode;
    console.log("company param from URL:", paramCompany);
    const [activeTab, setActiveTab] = useState('attendance');
    const [allStudents, setAllStudents] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState('');
    const [companies, setCompanies] = useState([]);
    const [companyName, setCompanyName] = useState('');
    const [trainerName, setTrainerName] = useState('');
    const [companyProgramName, setCompanyProgramName] = useState('');
    const [selectedCourse, setSelectedCourse] = useState('');
    const [courseList, setCourseList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [attendanceDates, setAttendanceDates] = useState([]);
    const [modules, setModules] = useState([]);
    const [modulesReport, setModulesReport] = useState([]);
    const [programCourses, setProgramCourses] = useState([]);
    const [selectedModuleReportCourse, setSelectedModuleReportCourse] = useState('');
    const [moduleNameMap, setModuleNameMap] = useState({});
    useEffect(() => {
        let localCompanyCode = paramCompany || localStorage.getItem("orgCode");

        // Clean up invalid or stringified null/undefined values
        if (!localCompanyCode || localCompanyCode === 'undefined' || localCompanyCode === 'null' || String(localCompanyCode).trim() === '') {
            localCompanyCode = null;
        }

      

        if (localCompanyCode) {
            setSelectedCompany(localCompanyCode);
        } else {
            console.log("Failed to Load Company");
        }
    }, [paramCompany]);

    // Fetch all data when company changes
    useEffect(() => {
        if (selectedCompany) {
            fetchCompanyData(selectedCompany);
        }
    }, [selectedCompany]);

    const fetchCompanyData = async (companyId) => {
        try {
            setLoading(true);

            let resolvedCompanyId = companyId;

            // Try to find a matching company ID if it doesn't exist directly
            try {
                const docRef = doc(db, `CorporateClients/${resolvedCompanyId}`);
                const snap = await getDoc(docRef);
                if (!snap.exists()) {
                    const clientsRef = collection(db, "CorporateClients");
                    const clientsSnap = await getDocs(clientsRef);
                    let candidates = [];
                    clientsSnap.forEach((clientDoc) => {
                        if (clientDoc.id.toLowerCase().includes(companyId.toLowerCase())) {
                            candidates.push(clientDoc.id);
                        }
                    });
                    if (candidates.length > 0) {
                        if (candidates.length === 1) {
                            resolvedCompanyId = candidates[0];
                        } else {
                            const loggedInStudentId = localStorage.getItem("studentId") || "Abhi_001"; //localstora
                            let found = false;
                            for (const candidate of candidates) {
                                const studentRef = doc(db, `CorporateClients/${candidate}/studentInfo/${loggedInStudentId}`);
                                const studentSnap = await getDoc(studentRef);
                                if (studentSnap.exists()) {
                                    resolvedCompanyId = candidate;
                                    found = true;
                                    break;
                                }
                            }
                            if (!found) {
                                resolvedCompanyId = candidates[0];
                            }
                        }
                    } 
                }
            } catch (err) {
                console.error("Error resolving companyId:", err);
            }

            // Try to read the company document to get a friendly companyName
            try {
                const companyRef = doc(db, `CorporateClients/${resolvedCompanyId}`);
                const companySnap = await getDoc(companyRef);
                if (companySnap.exists()) {
                    const data = companySnap.data();
                    setCompanyName(data?.companyName || resolvedCompanyId);
                    setTrainerName(data?.trainerName || '');
                    setCompanyProgramName(data?.programName || data?.programs || '');
                } else {
                    setCompanyName(resolvedCompanyId);
                    setTrainerName('');
                    setCompanyProgramName('');
                }
            } catch (e) {
                // fallback to resolvedCompanyId if any error
                setCompanyName(resolvedCompanyId);
                setTrainerName('');
                setCompanyProgramName('');
            }

            const studentsRef = collection(db, `CorporateClients/${resolvedCompanyId}/studentInfo`);
            const studentsSnapshot = await getDocs(studentsRef);

            const studentList = [];
            const allDates = new Set();
            const allModules = new Map(); // To store unique modules with course info
            const coursesSet = new Set(); // To store unique courses

            studentsSnapshot.forEach((doc) => {
                const studentFullName = doc.data().fullName || doc.id;

                // Skip students whose name contains "trainer" or "LSM" (case-insensitive)
                if (/trainer|lsm/i.test(studentFullName)) return;

                const studentData = {
                    id: doc.id,
                    fullName: studentFullName,
                    ...doc.data()
                };
                studentList.push(studentData);

                // Collect all dates from attendance
                if (doc.data().attendance) {
                    Object.keys(doc.data().attendance).forEach(date => {
                        allDates.add(date);
                    });
                }

                // Collect all modules with course information
                if (doc.data().marks) {
                    Object.entries(doc.data().marks).forEach(([course, modules_data]) => {
                        coursesSet.add(course);
                        Object.keys(modules_data).forEach(module => {
                            const key = `${course}|${module}`;
                            if (!allModules.has(key)) {
                                allModules.set(key, { course, module });
                            }
                        });
                    });
                }
            });

            // Sort dates
            const sortedDates = Array.from(allDates).sort();

            // Convert modules map to sorted array
            const sortedModules = Array.from(allModules.values()).sort((a, b) => {
                if (a.course !== b.course) return a.course.localeCompare(b.course);
                return a.module.localeCompare(b.module);
            });

            // Convert courses set to sorted array
            const sortedCourses = Array.from(coursesSet).sort();

            // Sort students by full name ascending and set once
            studentList.sort((a, b) => {
                const aName = (a.fullName || a.id || '').toString();
                const bName = (b.fullName || b.id || '').toString();
                return aName.localeCompare(bName, undefined, { sensitivity: 'base' });
            });

            // Filter student list to only show the logged-in student if not admin
            const loggedInStudentId = localStorage.getItem("studentId") || "Abhi_001";
            const isAdmin = localStorage.getItem("isAdmin") === "true";
            const filteredStudentList = (!isAdmin && loggedInStudentId)
                ? studentList.filter(student => student.id === loggedInStudentId)
                : studentList;

            setAllStudents(filteredStudentList);
            setAttendanceDates(sortedDates);
            setModules(sortedModules);
            setCourseList(sortedCourses);
            if (sortedCourses.length > 0) {
                // Default to showing all courses in the assessment report
                setSelectedCourse('all');
            }
            setError(null);

            // Fetch program info for modules report
            await fetchModulesReport(resolvedCompanyId);

            // Also attempt to fetch feedback subcollections for each student (some setups store feedback as subcollection docs)
            try {
                const feedbackPromises = filteredStudentList.map(async (stu) => {
                    try {
                        const feedbackRef = collection(db, `CorporateClients/${resolvedCompanyId}/studentInfo/${stu.id}/feedback`);
                        const feedbackSnap = await getDocs(feedbackRef);
                        if (!feedbackSnap.empty) {
                            const fbObj = {};
                            feedbackSnap.forEach((fdoc) => {
                                fbObj[fdoc.id] = fdoc.data();
                            });
                            // merge with any existing feedback field
                            stu.feedback = Object.assign({}, stu.feedback || {}, fbObj);
                        }
                    } catch (fbErr) {
                        console.warn('Failed to fetch feedback subcollection for', stu.id, fbErr);
                    }
                });

                await Promise.all(feedbackPromises);
            } catch (e) {
                console.warn('Error fetching per-student feedback subcollections', e);
            }
        } catch (err) {
            console.error('Error fetching company data:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Helper: extract numeric rating (0-10) from student object for sorting
    const extractRating = (student) => {
        const feedback = student.feedback || student.notes?.feedback || {};
        let ratingNum = null;

        if (feedback !== null && feedback !== undefined) {
            if (typeof feedback === 'object') {
                if (feedback.main && typeof feedback.main === 'object') {
                    ratingNum = ratingNum === null ? (feedback.main.rating || feedback.main.rate || feedback.main.ratingValue) : ratingNum;
                }
                ratingNum = ratingNum === null ? (feedback.rating || feedback.rate || feedback.ratingValue) : ratingNum;
            } else if (typeof feedback === 'string') {
                // no rating
            }
        }

        const parsed = Number(ratingNum);
        if (!Number.isNaN(parsed)) return Math.max(0, Math.min(10, parsed));
        return -1; // put unknown ratings at the end when sorting desc
    };

    const getFeedbackComments = (student) => {
        const feedback = student.feedback || student.notes?.feedback || {};

        if (feedback !== null && feedback !== undefined) {
            if (typeof feedback === 'string') {
                return feedback || '-';
            }

            if (typeof feedback === 'object') {
                if (feedback.main && typeof feedback.main === 'object') {
                    return feedback.main.comments || feedback.main.comment || feedback.comments || feedback.comment || feedback.notes || '-';
                }

                return feedback.comments || feedback.comment || feedback.notes || '-';
            }
        }

        return '-';
    };

    const isCapstoneCourse = (courseName) => /capstone/i.test(String(courseName || ''));

    const getCapstoneMarks = (student) => {
        const marks = student.marks || {};
        const capstoneKey = Object.keys(marks).find((key) => isCapstoneCourse(key));
        return capstoneKey ? marks[capstoneKey] || {} : {};
    };

    const getAttendancePercentage = (student) => {
        const attendance = student.attendance || {};
        const totalDays = Object.keys(attendance).length;
        if (totalDays === 0) return null;

        const presentDays = Object.values(attendance).filter(
            (status) => status === 'Present' || status === 'Late'
        ).length;

        return ((presentDays / totalDays) * 100).toFixed(2);
    };

    const getAssessmentPercentage = (student) => {
        const marks = student.marks || {};
        let totalScore = 0;
        let scoredModules = 0;

        Object.entries(marks).forEach(([courseName, modulesData]) => {
            if (isCapstoneCourse(courseName) || !modulesData || typeof modulesData !== 'object') return;

            Object.values(modulesData).forEach((moduleData) => {
                if (!moduleData || typeof moduleData !== 'object') return;

                const quiz = Number(moduleData.quiz);
                const hasQuiz = !Number.isNaN(quiz);

                if (!hasQuiz) return;

                totalScore += quiz;
                scoredModules += 1;
            });
        });

        if (scoredModules === 0) return null;

        return ((totalScore / (scoredModules * 25)) * 100).toFixed(2);
    };

    const getCapstonePercentage = (student) => {
        const capstoneData = getCapstoneMarks(student);
        const moduleScores = Object.values(capstoneData)
            .map((moduleData) => Number(moduleData?.assignment))
            .filter((value) => !Number.isNaN(value));

        if (moduleScores.length === 0) return null;

        const sum = moduleScores.reduce((acc, value) => acc + value, 0);
        return ((sum / (moduleScores.length * 10)) * 100).toFixed(2);
    };

    const getOverallRatingOutOf10 = (student) => {
        const rating = extractRating(student);
        if (rating < 0) return null;
        return (rating).toFixed(1);
    };

    const getOverallRatingStars = (student) => {
        const rating = getOverallRatingOutOf10(student);
        if (rating === null) return null;

        const filledStars = Math.max(0, Math.min(10, Math.round(Number(rating))));
        return '★'.repeat(filledStars);
    };

    const getOverallPercentage = (student) => {
        const metrics = [];

        const attendance = getAttendancePercentage(student);
        const assessment = getAssessmentPercentage(student);
        const capstone = getCapstonePercentage(student);
        const ratingOutOf10 = getOverallRatingOutOf10(student);

        if (attendance !== null) metrics.push(Number(attendance));
        if (assessment !== null) metrics.push(Number(assessment));
        if (capstone !== null) metrics.push(Number(capstone));
        if (ratingOutOf10 !== null) metrics.push((Number(ratingOutOf10) / 10) * 100);

        if (metrics.length === 0) return null;

        const average = metrics.reduce((sum, value) => sum + value, 0) / metrics.length;
        return average.toFixed(2);
    };

    const fetchModulesReport = async (companyId) => {
        try {
            const programInfoRef = collection(db, `CorporateClients/${companyId}/programInfo`);
            const programInfoSnapshot = await getDocs(programInfoRef);

            const modulesData = [];
            const moduleMap = {};
            const coursesSet = new Set();

            // Fetch modules for each course
            const coursePromises = [];
            programInfoSnapshot.forEach((courseDoc) => {
                const courseName = courseDoc.id;
                coursesSet.add(courseName);

                const modulesRef = collection(db, `CorporateClients/${companyId}/programInfo/${courseName}/modules`);
                coursePromises.push(
                    getDocs(modulesRef).then((modulesSnapshot) => {
                        modulesSnapshot.forEach((moduleDoc) => {
                            const moduleData = moduleDoc.data();
                            const displayName =
                                moduleData.name ||
                                moduleData.moduleName ||
                                moduleDoc.id;

                            moduleMap[`${courseName}|${moduleDoc.id}`] =
                                displayName;

                            modulesData.push({
                                id: moduleDoc.id,
                                course: courseName,
                                moduleName: displayName,
                                startDate: moduleData.startDate || '-',
                                endDate: moduleData.endDate || '-',
                                status: moduleData.status || '-'
                            });
                        });
                    })
                );
            });

            // Wait for all module fetches to complete
            await Promise.all(coursePromises);

            const courseIds = Array.from(coursesSet).sort();
            setProgramCourses(courseIds);
            setModulesReport(modulesData);
            setModuleNameMap(moduleMap);

            // Set default selected course for modules report
            if (courseIds.length > 0) {
                setSelectedModuleReportCourse(courseIds[0]);
            }
        } catch (err) {
            console.error('Error fetching modules report:', err);
        }
    };

    // Format various date string shapes to dd-mm-yyyy for display
    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        // already in dd-mm-yyyy
        if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) return dateStr;
        const d = new Date(dateStr);
        if (!isNaN(d)) {
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            return `${dd}-${mm}-${yyyy}`;
        }
        // fallback: extract numeric parts
        const parts = String(dateStr).match(/\d+/g);
        if (parts && parts.length >= 3) {
            if (parts[0].length === 4) {
                // YYYY-MM-DD -> DD-MM-YYYY
                return `${parts[2].padStart(2, '0')}-${parts[1].padStart(2, '0')}-${parts[0]}`;
            }
            // assume DD MM YYYY or MM DD YYYY -> take last as year
            return `${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}-${parts[2]}`;
        }
        return String(dateStr);
    };

    const renderAttendanceReport = () => {
        if (allStudents.length === 0) {
            return <div className="no-data">No attendance data available</div>;
        }

        return (
            <div className="report-container">
                <div className="excel-table-wrapper attendance-wrapper">
                    <table className="excel-table attendance-table">
                        <thead>
                            <tr>
                                <th className="sticky-col">Student Name</th>
                                {attendanceDates.map((date) => (
                                    <th key={date} className="date-col">
                                        {formatDate(date)}
                                    </th>
                                ))}
                                <th className="total-col">Total Days</th>
                                <th className="percentage-col">Attendance %</th>
                            </tr>
                        </thead>
                        <tbody>
                            {([...allStudents].sort((a, b) => {
                                const aName = (a.fullName || a.id || '').toString();
                                const bName = (b.fullName || b.id || '').toString();
                                return aName.localeCompare(bName, undefined, { sensitivity: 'base' });
                            })).map((student) => {
                                const attendance = student.attendance || {};
                                // Count Present and Late as present
                                const presentDays = Object.values(attendance).filter(
                                    (status) => status === 'Present' || status === 'Late'
                                ).length;
                                const totalDays = Object.keys(attendance).length;
                                const percentage =
                                    totalDays > 0 ? ((presentDays / totalDays) * 100).toFixed(2) : 0;

                                return (
                                    <tr key={student.id}>
                                        <td className="sticky-col student-name">{student.fullName}</td>
                                        {attendanceDates.map((date) => (
                                            <td
                                                key={`${student.id}-${date}`}
                                                className={`attendance-cell date-col ${attendance[date]?.toLowerCase() || 'absent'
                                                    }`}
                                            >
                                                {attendance[date] ? attendance[date].charAt(0) : '-'}
                                            </td>
                                        ))}
                                        <td className="total-col">{totalDays}</td>
                                        <td className="percentage-col">
                                            <strong>{percentage}%</strong>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    const renderModuleWiseReport = () => {

        if (allStudents.length === 0 || modules.length === 0) {
            return <div className="no-data">No module data available</div>;
        }

        const assessmentCourses = courseList.filter(course => !isCapstoneCourse(course));

        const renderCourseTable = (courseName) => {
            const courseModulesFiltered = modules.filter((m) => m.course === courseName);

            if (courseModulesFiltered.length === 0) {
                return (
                    <div key={courseName} className="no-data">
                        No modules available for {courseName}
                    </div>
                );
            }

            const isCompetencyAssessment = /competency/i.test(courseName);
            const colSpanCount = isCompetencyAssessment ? 2 : 3;

            const moduleNames = courseModulesFiltered.map((m) => ({
                id: m.module,
                name:
                    moduleNameMap?.[`${courseName}|${m.module}`] ||
                    m.module
            }));
            console.log(moduleNames)
            return (
                <div key={courseName} className="assessment-course-section">


                    <div className="excel-table-wrapper">
                        <table className="excel-table modules-table hierarchical">
                            <thead>
                                <tr className="course-header-row">
                                    <th rowSpan="3" className="sticky-col">
                                        Student Name
                                    </th>
                                    <th
                                        colSpan={moduleNames.length * colSpanCount}
                                        className="course-merged-header"
                                    >
                                        {courseName}
                                    </th>
                                </tr>

                                <tr className="module-header-row">
                                    {moduleNames.map((module) => (
                                        <th
                                            key={`${courseName}|${module.id}`}
                                            colSpan={colSpanCount}
                                            className="module-merged-header"
                                        >
                                            {module.name}
                                        </th>
                                    ))}
                                </tr>

                                <tr className="subheader-row">
                                    {moduleNames.map((module) => (
                                        <React.Fragment key={`${courseName}|${module.id}`}>
                                            {!isCompetencyAssessment && (
                                                <th className="subheader">Assignment <br></br>
                                                    <span className="marks-subtext"> (Out of 25)</span>
                                                </th>
                                            )}
                                            <th className="subheader">Quiz <br></br><span className="marks-subtext"> (Out of 25)</span></th>
                                            <th className="subheader percentage-subheader" style={{ background: '#3ca15e' }}>
                                                Percentage (%)
                                            </th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {([...allStudents].slice().sort((a, b) => {
                                    // sort by rating desc, unknown ratings at the end, then by name asc
                                    const r = extractRating(b) - extractRating(a);
                                    if (r !== 0) return r;
                                    const aName = (a.fullName || a.id || '').toString();
                                    const bName = (b.fullName || b.id || '').toString();
                                    return aName.localeCompare(bName, undefined, { sensitivity: 'base' });
                                })).map((student) => {
                                    const marks = student.marks || {};

                                    return (
                                        <tr key={`${courseName}|${student.id}`}>
                                            <td className="sticky-col student-name">{student.fullName}</td>
                                            {moduleNames.map((module) => {
                                                const courseMarks = marks[courseName] || {};
                                                const moduleMarks =
                                                    courseMarks[module.id] || {};
                                                const quiz = parseFloat(moduleMarks.quiz);
                                                const assignment = parseFloat(moduleMarks.assignment);
                                                const hasQuiz = !Number.isNaN(quiz);
                                                const hasAssignment = !Number.isNaN(assignment);
                                                let totalScore = 0;
                                                let totalMax = 0;
                                                if (hasQuiz) { totalScore += quiz; totalMax += 25; }
                                                if (hasAssignment && !isCompetencyAssessment) { totalScore += assignment; totalMax += 25; }
                                                const percentage =
                                                    totalMax > 0 ? ((totalScore / totalMax) * 100).toFixed(1) : '-';

                                                return (
                                                    <React.Fragment key={`${courseName}|${student.id}|${module.id}`}>
                                                        {!isCompetencyAssessment && (
                                                            <td className="data-cell assignment-cell">
                                                                {moduleMarks.assignment !== undefined && moduleMarks.assignment !== null && moduleMarks.assignment !== '' ? moduleMarks.assignment : 'NA'}
                                                            </td>
                                                        )}
                                                        <td className="data-cell quiz-cell">
                                                            {moduleMarks.quiz || '-'}
                                                        </td>
                                                        <td className="data-cell percentage-cell">
                                                            <strong>{percentage} %</strong>
                                                        </td>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        };

        return (
            <div className="report-container">
                <div className="course-selector-wrapper">
                    <label htmlFor="module-course-select">Select Course:</label>
                    <select
                        id="module-course-select"
                        value={selectedCourse}
                        onChange={(e) => setSelectedCourse(e.target.value)}
                        className="select-dropdown"
                    >
                        <option value="all">All</option>
                        {courseList
                            .filter(course => !isCapstoneCourse(course)) // hide any course containing capstone
                            .map((course) => (
                                <option key={course} value={course}>
                                    {course}
                                </option>
                            ))}
                    </select>
                </div>

                {selectedCourse === 'all' ? (
                    <div className="assessment-all-courses">
                        {assessmentCourses.length > 0 ? (
                            assessmentCourses.map((course) => renderCourseTable(course))
                        ) : (
                            <div className="no-data">No modules available (excluding CapstoneProject)</div>
                        )}
                    </div>
                ) : selectedCourse ? (
                    renderCourseTable(selectedCourse)
                ) : (
                    <div className="no-data">No modules available for selected course</div>
                )}
            </div>
        );
    };

    const renderModulesReport = () => {
        if (modulesReport.length === 0) {
            return <div className="no-data">No modules data available</div>;
        }

        const grouped = modulesReport.reduce((acc, module) => {
            const course = module.course || 'Unknown';
            if (isCapstoneCourse(course)) return acc;
            if (!acc[course]) acc[course] = [];
            acc[course].push(module);
            return acc;
        }, {});

        const courseNames = Object.keys(grouped).sort();

        if (courseNames.length === 0) {
            return <div className="no-data">No modules available (excluding capstone)</div>;
        }

        return (
            <div className="report-container assessment-all-courses">
                {courseNames.map((course) => (
                    <div key={`group-${course}`} className="assessment-course-section">
                        <div className="assessment-course-title">{course}</div>
                        <div className="excel-table-wrapper">
                            <table className="excel-table modules-report-table">
                                <thead>
                                    <tr className="course-header-row">
                                        <th className="module-name-col">Module Name</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {grouped[course].map((module) => (
                                        <tr key={`${course}|${module.id}`}>
                                            <td className="module-name-col">{module.moduleName}</td>
                                            <td>{module.startDate}</td>
                                            <td>{module.endDate}</td>
                                            <td>
                                                <span className={`status-badge ${String(module.status || '').toLowerCase()}`}>
                                                    {module.status}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    const renderCapstoneProject = () => {
        if (allStudents.length === 0) {
            return <div className="no-data">No capstone data available</div>;
        }

        // Get all unique module names across all students
        const allModuleNames = new Set();
        allStudents.forEach((student) => {
            const capstoneData = getCapstoneMarks(student);
            Object.keys(capstoneData).forEach(moduleName => {
                allModuleNames.add(moduleName);
            });
        });

        const moduleNames = Array.from(allModuleNames).sort();

        return (
            <div className="report-container">
                <div className="excel-table-wrapper">
                    <table className="excel-table capstone-table hierarchical">
                        <thead>
                            {/* First header row with module names */}
                            <tr className="module-header-row">
                                <th className="sticky-col" rowSpan="2">Student Name</th>
                                <th rowSpan="2">GitHub URL</th>
                                {moduleNames.map((moduleName) => (
                                    <th key={moduleName} className="module-merged-header">
                                        {moduleName}
                                    </th>
                                ))}
                                <th rowSpan="2" className="module-merged-header" style={{ backgroundColor: '#095F73' }}>
                                    Overall Percentage (%)
                                </th>
                            </tr>
                            {/* Second header row with Score subheaders */}
                            <tr className="subheader-row">
                                {moduleNames.map((moduleName) => (
                                    <th key={`${moduleName}-sub`} className="subheader">Score <br /> (Out of 10)</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {allStudents.map((student) => {
                                // Try to get GitHub URL from multiple possible field names
                                let githubUrl = student.githubURL || student.githubUrl;

                                // If it's just a username without URL, convert to full GitHub URL
                                if (githubUrl && !githubUrl.startsWith('http')) {
                                    githubUrl = `https://github.com/${githubUrl}`;
                                }

                                // Get capstone data from any marks key containing "capstone"
                                const capstoneData = getCapstoneMarks(student);

                                return (
                                    <tr key={student.id}>
                                        <td className="sticky-col student-name">{student.fullName}</td>
                                        <td>
                                            {githubUrl ? (
                                                <a
                                                    href={githubUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="link-btn"
                                                >
                                                    {githubUrl}
                                                </a>
                                            ) : (
                                                <span>-</span>
                                            )}
                                        </td>
                                        {moduleNames.map((moduleName) => {
                                            const moduleData = capstoneData[moduleName] || {};
                                            const assignment = moduleData.assignment !== undefined ? moduleData.assignment : '-';

                                            return (
                                                <React.Fragment key={`${student.id}|${moduleName}`}>
                                                    <td className="percentage-cell" style={{ backgroundColor: 'white' }}>
                                                        <strong>{assignment}</strong>
                                                    </td>
                                                </React.Fragment>
                                            );
                                        })}
                                        {/* Overall percentage across all modules (each out of 10) */}
                                        {(() => {
                                            const scores = moduleNames.map((m) => {
                                                const v = capstoneData[m]?.assignment;
                                                return v !== undefined && !isNaN(Number(v)) ? Number(v) : null;
                                            }).filter(v => v !== null);

                                            if (scores.length === 0) {
                                                return (
                                                    <td className="percentage-cell"><strong>-</strong></td>
                                                );
                                            }

                                            const sum = scores.reduce((a, b) => a + b, 0);
                                            const totalPossible = moduleNames.length * 10;
                                            const overallPercent = ((sum / totalPossible) * 100).toFixed(1);

                                            return (
                                                <td className="percentage-cell"><strong>{`${overallPercent}%`}</strong></td>
                                            );
                                        })()}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    const renderConsolidatedReport = () => {
        if (allStudents.length === 0) {
            return <div className="no-data">No consolidated data available</div>;
        }

        const consolidatedStudents = [...allStudents].sort((a, b) => {
            const aScore = Number(getOverallPercentage(a));
            const bScore = Number(getOverallPercentage(b));

            const aHasScore = !Number.isNaN(aScore);
            const bHasScore = !Number.isNaN(bScore);

            if (aHasScore && bHasScore && aScore !== bScore) {
                return bScore - aScore;
            }

            if (aHasScore !== bHasScore) {
                return aHasScore ? -1 : 1;
            }

            const aName = (a.fullName || a.id || '').toString();
            const bName = (b.fullName || b.id || '').toString();
            return aName.localeCompare(bName, undefined, { sensitivity: 'base' });
        });

        return (
            <div className="report-container">
                <div className="excel-table-wrapper consolidated-wrapper">
                    <table className="excel-table consolidated-table">
                        <colgroup>
                            <col style={{ width: '18%' }} />
                            <col style={{ width: '12%' }} />
                            <col style={{ width: '12%' }} />
                            <col style={{ width: '12%' }} />
                            <col style={{ width: '14%' }} />
                            <col style={{ width: '24%' }} />
                            <col style={{ width: '8%' }} />
                        </colgroup>
                        <thead>
                            <tr>
                                <th className="sticky-col">Student Name</th>
                                {/* <th>Email</th> */}
                                <th>Attendance <br /> (%)</th>
                                <th>Assessment <br /> (%)</th>
                                <th>Capstone Project <br /> (%)</th>
                                <th>Trainer's Rating <br></br>(out of 10)</th>
                                <th>Trainer's Comments</th>
                                <th>Consolidated <br />(%)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {consolidatedStudents.map((student) => {
                                const attendancePercentage = getAttendancePercentage(student);
                                const assessmentPercentage = getAssessmentPercentage(student);
                                const capstonePercentage = getCapstonePercentage(student);
                                const overallRating = getOverallRatingOutOf10(student);
                                const overallRatingStars = getOverallRatingStars(student);
                                const comments = getFeedbackComments(student);
                                const overallPercentage = getOverallPercentage(student);

                                return (
                                    <tr key={student.id}>
                                        <td className="sticky-col student-name">{student.fullName || student.id}</td>
                                        {/* <td>{student.email || student.emailId || '-'}</td> */}
                                        <td>{attendancePercentage ? `${attendancePercentage}%` : '-'}</td>
                                        <td>{assessmentPercentage ? `${assessmentPercentage}%` : '-'}</td>
                                        <td>{capstonePercentage ? `${capstonePercentage}%` : '-'}</td>
                                        <td className="star-cell">
                                            {overallRatingStars ? <span className="star-rating">{overallRatingStars}</span> : '-'}
                                            {overallRating ? <span style={{ marginLeft: 8, color: '#333' }}>{`${overallRating}`}</span> : null}
                                        </td>
                                        <td className="comments-cell">{comments}</td>
                                        <td>{overallPercentage ? `${overallPercentage}%` : '-'}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    return (
        <div className="container">
            {/* <div className="company-header">
                <div className="company-name">
                    <strong>Client Name : </strong>

                    <span className="company-value">{companyName || ''}</span>
                </div>
                <div className="company-program">
                    <strong>Program Name : </strong>

                    <span className="company-value">{companyProgramName || ''}</span>
                </div>
                <div className="company-trainer">
                    <strong>Trainer's Name : </strong>

                    <span className="company-value">{trainerName || ''}</span>
                </div>
            </div> */}
            {error && <div className="error">Error: {error}</div>}

            {!loading && (
                <>
                    {allStudents.length > 0 && (
                        <>
                            <div className="tabs">
                                {/* <button
                                    className={`tab-button ${activeTab === 'modulesreport' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('modulesreport')}
                                >
                                    Modules Progress Report
                                </button> */}
                                <button
                                    className={`tab-button ${activeTab === 'attendance' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('attendance')}
                                >
                                    Attendance Report
                                </button>
                                <button
                                    className={`tab-button ${activeTab === 'modules' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('modules')}
                                >
                                    Assessment Report
                                </button>
                                {/* <button
                                    className={`tab-button ${activeTab === 'capstone' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('capstone')}
                                >
                                    Capstone Project
                                </button> */}
                                { <button
                                    className={`tab-button ${activeTab === 'feedback' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('feedback')}
                                >
                                    Consolidated Report
                                </button>}

                            </div>

                            <div className="tab-content">
                                {activeTab === 'attendance' && renderAttendanceReport()}
                                {activeTab === 'modules' && renderModuleWiseReport()}
                                {activeTab === 'capstone' && renderCapstoneProject()}
                                {activeTab === 'feedback' && renderConsolidatedReport()}
                                {activeTab === 'modulesreport' && renderModulesReport()}
                            </div>
                        </>
                    )}
                </>
            )}

            {loading && <div className="loading">Loading data...</div>}
        </div>
    );
}
